import {
  useRef, useState,
  type DragEvent,
} from 'react';
import Button from '../../../juristec-ui/core/Button';
import { DesktopUpload, File } from '../../../juristec-ui/icons';
import {
  UploadArea,
  UploadBorder,
  UploadOpts,
  FileInfoContainer,
  FileInfo,
  MainContainer,
} from './styled';
import { verifyFileSheetType } from '../../../juristec-ui/utils/validators/fileValidators';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';

interface SelectedFile {
  file: File | null;
  errorMsg: string;
}

interface UploadModelProps {
  hide: () => void;
  submit: (file: File) => void;
}

const UploadModel = ({
  hide, submit,
}: UploadModelProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<SelectedFile>({ file: null, errorMsg: '' });
  const [dragging, setDragging] = useState(false);

  const dragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(true);
  };

  const dragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const dragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleFile = (files: FileList) => {
    const errorMsg = verifyFileSheetType(files[0]);
    setSelectedFile({
      file: errorMsg.length === 0 ? files[0] : null,
      errorMsg,
    });
  };

  const fileDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files;
    if (file.length) {
      handleFile(file);
    }
  };

  const fileSelected = () => {
    if (fileInputRef.current?.files?.length) {
      handleFile(fileInputRef.current.files);
    }
  };

  const handleSubmit = () => {
    if (selectedFile.errorMsg.length === 0 && selectedFile.file) {
      submit(selectedFile.file);
    }
  };

  return (
    <>
      <MainContainer>
        <UploadArea
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          onDrop={fileDrop}
          dragging={dragging}
        >
          <UploadBorder>
            <span>
              Arraste um arquivo
              {' '}
              <b>.xlsx</b>
              {' '}
              ou
              {' '}
              <b>.csv</b>
            </span>
            <span><b>ou</b></span>
            <UploadOpts>
              <input
                ref={fileInputRef}
                className="file-input"
                type="file"
                accept=".xlsx, .xls, .csv"
                style={{ display: 'none' }}
                onChange={fileSelected}
              />
              <Button
                size="small"
                shape="rounded"
                onClick={() => fileInputRef.current?.click()}
                className="modal_upload_file"
              >
                <DesktopUpload />
                Procure no dispositivo...
              </Button>
            </UploadOpts>
            <FileInfoContainer>
              <>
                {selectedFile.errorMsg.length > 0 ? (
                  <span className="errorMsg">{selectedFile.errorMsg}</span>
                ) : (
                  selectedFile.file && (
                    <FileInfo>
                      <File />
                      <span>{selectedFile.file.name}</span>
                    </FileInfo>
                  )
                )}
              </>
            </FileInfoContainer>
          </UploadBorder>
        </UploadArea>
      </MainContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={hide}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={!selectedFile.file || selectedFile.errorMsg.length > 0}
        >
          Adicionar
        </Button>
      </ActionsGroup>
    </>
  );
};

export default UploadModel;
